import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`
const Dot = styled.div`
  width: ${({ $isActive }) => ($isActive ? '16px' : '8px')};
  height: 8px;
  border-radius: ${({ $isActive }) => ($isActive ? '5px' : '50%')};
  background-color: ${({ $isActive, theme }) => ($isActive ? theme.colors.secondary : theme.colors.neutral[300])};
  cursor: pointer;
`

const Indicator = ({len, currentIndex, onClick}) => {
  return (
    <Wrapper>
      {Array.from({ length: len }).map((_, index) => (
        <Dot
          key={index}
          $isActive={index === currentIndex}
          onClick={() => onClick(index)}
        />
      ))}
    </Wrapper>

  )
}

export default Indicator
